import React, { useState } from 'react';

import { Box, Chip, TextField, Autocomplete } from '@mui/material';
import { useMetadata } from '../../../../providers/MetadataContext';

function InvestmentStrategyFilter({ value, setValue }) {
  const metadata = useMetadata();
  const [selected, setSelected] = useState(
    value.map((entity_id) => {
      return (metadata?.sponsor?.lists?.investment_strategies || []).find(
        (option) => option.entity_id === entity_id
      );
    })
  );

  const handleChange = (event, newValue) => {
    setSelected(newValue);
    setValue(newValue.map((option) => option.entity_id));
  };

  return (
    <Box>
      <Autocomplete
        multiple
        id='investment-strategies-filter'
        options={metadata?.sponsor?.lists?.investment_strategies || []}
        value={selected}
        onChange={handleChange}
        getOptionLabel={(option) => `${option.name}`}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip label={option.name} {...getTagProps({ index })} />
          ))
        }
        renderInput={(params) => (
          <TextField {...params} label='Investment Strategies' />
        )}
      />
    </Box>
  );
}

export default InvestmentStrategyFilter;
